import React, { useEffect, useState } from 'react';
import { Box, Drawer, IconButton, Link, Menu, MenuItem } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  BellIcon,
  CheckGreenCircle,
  LogOutIcon,
  LogoIcon,
  LogoSmallIcon,
  MoreDotIcon
} from 'assets';
import MenuIcon from '@mui/icons-material/Menu';
import { SideBarListType } from 'models/enum';
import { useLocation, useNavigate } from 'react-router-dom';
import { colors } from 'styles/colors';
import {
  TurnOnNotificationIcon,
  CreateIconNew,
  CreateActiveIconNew,
  CreatePostIcon,
  CreatePollIcon,
  CreateGroupIconGrey,
  GroupsActiveIcon,
  GroupsIcon,
  HomeActiveIcon,
  HomeIcon,
  NotificationIcon,
  SettingsIcon,
  NotificationActiveIcon,
  ChatScreenActiveIcon,
  ChatScreenIcon,
  HomeIconNew,
  HomeActiveIconNew
} from 'assets/icon';
import {ReportProblemIcon} from "assets";
import AvatarImg from 'pages/components/avatarImg';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { RootState } from 'store';
import { setLogIn } from 'store/authSlice';
import TypographyWithI18N from 'pages/components/TypographyWithI18N';
import AdminIconButton from 'pages/components/iconButton';
import { useTranslation } from 'react-i18next';
import { userProfileUrl } from 'utilities/userImageURL';
import { ApiPaths, IGuestModeOptions } from 'models/apiPaths';
import {
  axiosLogout,
  createOrUpdateUserStatusActiveStatus,
  fetchUserDetails,
  getNotificationCount
} from 'services/api';
import ConfirmationModal from 'pages/components/confirmationModal';
import SigninModal from 'pages/components/signinModal';
import DialogActionWall from 'pages/components/dialogActionWall';
import { appAccountValidation, swmAccountValidation } from 'utilities/authTokenValidation';
import { setFeatureFlag } from 'store/featureFlagSlice';
import { closeSignalRConnection } from 'services/SignalRService';
import ReportProblem from 'pages/authentication/ReportProblem';
import PrivacyPolicy from 'pages/authentication/privacyPolicy';
import TermsOfUse from 'pages/authentication/termsOfUse';
import { isOAuthFlowActive } from 'utilities/oauthBridge';

interface IListItem {
  title: string;
  active: boolean;
  count: number;
  subList?: IListItem[];
  link: string;
  disabled?: boolean;
}
interface IOpenDialog {
  open: boolean;
  message?: string;
  label?: string;
  userId?: string;
  username?: string;
  loaderBtn?: boolean;
  confirmTxt?: boolean;
}
interface IOpenDialog {
  open: boolean;
  id?: string;
  loaderBtn?: boolean;
  successModal?: boolean;
}
interface ISideBar {
  isLoggedIn?: boolean;
}
const SideBar = ({ isLoggedIn }: ISideBar) => {
  const { t } = useTranslation();
  const navigate: any = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { userProfile, authToken }: any = useAppSelector(
    (state: RootState) => state.userAuth
  );
  const [confirmModal, setConfirmModal] = React.useState<IOpenDialog>();
  const [isNotification, setIsNotification] = React.useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<IOpenDialog>({
    open: false,
    id: '',
    loaderBtn: false,
    successModal: false
  });
  const [guestModeOptions, setGuestModeOptions] = useState<IGuestModeOptions>({
    guestMode: false,
    navigateTo: null,
    menu: null,
    redirectTo: null,
    action: null,
    actionItem: null
  });
  const [openSigninDialog, setOpenSigninDialog] = useState<boolean>(false);
  const openMenu = Boolean(anchorEl);
  const { isChatEnabled }: any = useAppSelector(
    (state: RootState) => state.featureFlag
  );
  const isAppAccount = appAccountValidation?.(authToken ?? null);
  const isSWMAccount = swmAccountValidation?.(authToken ?? null);
  const [openReportProblem, setOpenReportProblem] = useState(false);
  const [createAnchorEl, setCreateAnchorEl] = React.useState<null | HTMLElement>(null);
  const createMenuOpen = Boolean(createAnchorEl);
  const [openPrivacyModal, setOpenPrivacyModal] = useState(false);
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const currentYear = new Date().getFullYear();

  const listItems: IListItem[] = [
    {
      title: 'Home',
      active: true,
      count: 2,
      link: 'home'
    },
    {
      title: 'Groups',
      active: false,
      count: 0,
      link: 'groups',
      disabled: isAppAccount || isSWMAccount
    },
    {
      title: 'Create',
      active: false,
      count: 0,
      subList: [
        {
          title: 'Post',
          active: false,
          count: 0,
          link: 'createPost'
        }, {
          title: 'Poll',
          active: false,
          count: 0,
          link: 'createPoll'
        },
        {
          title: 'Group',
          active: false,
          count: 0,
          link: 'createGroup',
          disabled: isAppAccount || isSWMAccount
        }
      ],
      link: 'create'
    },
    ...(isChatEnabled
      ? [
        {
          title: 'Chat',
          active: false,
          count: 0,
          link: 'chat',
          disabled: isAppAccount || isSWMAccount
        }
      ]
      : []),
    {
      title: 'Notification',
      active: false,
      count: 0,
      link: 'notification'
    }
  ];

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [nestedMenuOpen, setNestedMenuOpen] = React.useState(false);

  const handleCreateMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setCreateAnchorEl(event.currentTarget);
  };
  const handleCreateMenuClose = () => {
    setCreateAnchorEl(null);
  };

  const clearLocalStorage = ()=>{
    localStorage.removeItem('chats-last-tab')
    localStorage.removeItem('groups-last-tab')
    localStorage.removeItem('group-last-tab')
    localStorage.removeItem('last-group')
    localStorage.removeItem('user-tab-list')
  }

  const dispatch = useAppDispatch();
  const logOutClick = async () => {
    setOpenDialog((pv: any) => ({
      ...pv,
      successModal: true
    }));
    try {
      await createOrUpdateUserStatusActiveStatus({ online: false });
      await axiosLogout();
      clearLocalStorage();
      setTimeout(() => {
        dispatch(
          setLogIn({
            authToken: null,
            isLoggedIn: false
          })
        );
        dispatch(
          setFeatureFlag({
            isChatEnabled: true
          })
        );
        if (isChatEnabled) {
          dispatch(closeSignalRConnection());
        }
        navigate('');
      }, 1000);
    }
    catch (error) {
      console.error("Logout failed:", error);
    }
  }
  const userProfileDetails = async () => {
    if (isOAuthFlowActive()) {
      return;
    }
    const userProfile = await fetchUserDetails(ApiPaths.ME);
    dispatch(
      setLogIn({
        isLoggedIn: true,
        authToken: authToken,
        userProfile: {
          ...userProfile
        }
      })
    );
  };

  const notificationHandler = async () => {
    if (isOAuthFlowActive()) {
      return;
    }
    try {
      const notification = await getNotificationCount();
      if (notification) {
        Number(notification?.unreadNotifications) > 0
          ? setIsNotification(true)
          : setIsNotification(false);
      }
    } catch (error: unknown) {
      setIsNotification(false);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      userProfileDetails();
    }
  }, [authToken]);

  useEffect(() => {
    if (userProfile?.notificationCount?.length > 0) {
      // const readCountValue =
      //   userProfile?.notificationCount.filter((x: any) => x > 0).length > 0;
      notificationHandler();
    }
  }, [userProfile?.notificationCount]);

  // isToken Expired
  useEffect(() => {
    if (isLoggedIn) {
      notificationHandler();
    }
  }, [location]);

  const iconList = (type: string, active: boolean) => {
    switch (type) {
      case SideBarListType.home:
        return active ? <HomeActiveIconNew /> : <HomeIconNew />;
      case SideBarListType.groups:
        return active ? <GroupsActiveIcon /> : <GroupsIcon />;
      case SideBarListType.create:
        return active ? <CreateActiveIconNew /> : <CreateIconNew />;
      case SideBarListType.chat:
        return active ? <ChatScreenActiveIcon /> : <ChatScreenIcon />;
      case SideBarListType.notification:
        return active ? (
          !isNotification ? (
            <TurnOnNotificationIcon
              style={{
                width: 24,
                height: 24,
                marginLeft: '0px',
                stroke: '#028383',
                strokeWidth: '0.5px',
              }}
            />
          ) : (
            <NotificationActiveIcon />
          )
        ) : !isNotification ? (
          <TurnOnNotificationIcon
            style={{
              width: 24,
              height: 24,
              color:"black",
              stroke: '#1C1B1F',
              strokeWidth: '0.5px',
            }}
          />
        ) : (
          <NotificationIcon />
        );
      case SideBarListType.settings:
        return active ? <SettingsIcon /> : <SettingsIcon />;
      case SideBarListType.createPost:
        return active ? <CreatePostIcon /> : <CreatePostIcon />;
      case SideBarListType.createPoll:
        return active ? <CreatePollIcon /> : <CreatePollIcon />;
      case SideBarListType.createGroup:
        return active ? <CreateGroupIconGrey /> : <CreateGroupIconGrey />;
      default:
        return false;
    }
  };
  const itemSelected = (link: string, subList?: IListItem[]) => {
    const pathNames = location.pathname.split('/').filter((x) => x);
    return subList ? pathNames[0]?.startsWith(link) : pathNames[0] === link ? true : false;
  };

  const userNameActive = (userId: string) => {
    const pathId = location.pathname.split('/').filter((x) => x)[1];
    return userId === pathId;
  };

  const openSigninModal = (itm: IListItem | undefined) => {
    setGuestModeOptions({
      guestMode: true,
      navigateTo: itm?.link || 'home',
      menu: itm?.title || 'home',
      redirectTo: '/' + (itm?.link || 'home'),
      action: itm?.title || 'home',
      actionItem: null
    });
    setOpenSigninDialog(true);
  }

  const buttonProps = (itm: IListItem) => (
    itm.disabled ? {
      onClick: () => { },
    } : itm.subList ? {
      onClick: handleCreateMenuOpen,
    } : {
      selected: itm.link ? itemSelected(itm.link) : undefined,
    onClick: isLoggedIn ? () => { navigate('/' + itm.link); } : () => { openSigninModal(itm) },
    }
  );


  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const renderListItems = (items: IListItem[]) => {
    return items.map((_itm, index) => (
      <React.Fragment key={`${index}_list`}>
        <ListItem
          {...buttonProps(_itm)}
          disabled={_itm.disabled}
          sx={{
            cursor: _itm.disabled ? 'not-allowed' : 'pointer',
            height: _itm.title === 'Create' ? 43 : 50,
            justifyContent: 'center',
            opacity: _itm.disabled ? 0.5 : 1,
            ...( _itm.title === 'Create' && 
            {
              background: colors.text.primaryTheme,
              color: colors.text.primaryWhite,
              borderRadius: '12px',
              margin: '8px 0px'
            }),

            '&.Mui-selected': {
              background:
                _itm.title === 'Create'
                  ? colors.text.primaryTheme
                  : colors.background.white
            }
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 56, color: _itm.title === 'Create' ? '#fff' : 'inherit'
            }}
          >
            {iconList(_itm.title, itemSelected(_itm.link, _itm.subList))}
          </ListItemIcon>

          <ListItemText
            primary={_itm.title === 'Groups' ? 'Connections' : _itm.title}
            primaryTypographyProps={{
              color:
                _itm.title === 'Create'
                  ? '#fff'
                  : itemSelected(_itm.link, _itm.subList)
                  ? colors.text.primaryTheme
                  : colors.text.primaryBlack,
              fontSize: '18px',
              fontStyle: 'normal',
              fontWeight: itemSelected(_itm.link, _itm.subList) ? '700' : '400',
              lineHeight: 'normal',
              display: { xs: 'block', md: 'block' }
            }}
          />
          {_itm.subList ? createMenuOpen ? <ExpandLess sx={{color:'#fff' , rotate: '90deg'}} /> : <ExpandMore sx={{color:'#fff'}}/> : null}
        </ListItem>
        {_itm.subList && (
          <Menu
            anchorEl={createAnchorEl}
            open={createMenuOpen}
            onClose={handleCreateMenuClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            sx={{
              '& .MuiPaper-root': {
                borderRadius: '16px',
                minWidth: 200,
                boxShadow: '0px 8px 24px rgba(0,0,0,0.12)',
                ml: 1,
              }
            }}
          >
            {_itm.subList.map((_subItm, idx) => (
              <MenuItem
                key={idx}
                disabled={_subItm.disabled}
                id={_subItm.link}
                data-testid={_subItm.link}
                onClick={() => {
                  handleCreateMenuClose();
                  if (!isLoggedIn) {
                    openSigninModal(_subItm);
                  } else {
                    navigate('/' + _subItm.link);
                  }
                }}
                sx={{
                  gap: 1.5,
                  py: 1.5,
                  px: 2.5,
                  fontSize: '16px',
                  fontWeight: 500,
                  color: colors.text.primaryBlack,
                  '&:hover': {
                    color: colors.text.primaryTheme,
                    background: 'rgba(0,0,0,0.04)',
                    '& .MuiListItemIcon-root': {
                      color: colors.text.primaryTheme,
                    },
                    '& svg circle ': {
                      fill: 'none',
                      stroke: colors.text.primaryTheme,
                    },
                  '& svg path, & svg rect':{
                      fill: colors.text.primaryTheme,
                      stroke: 'none',
                    }
                  }
                }}
              >
                <ListItemIcon sx={{ minWidth: 36, color: colors.text.primaryTheme }}>
                  {iconList(_subItm.title, itemSelected(_subItm.link))}
                </ListItemIcon>
                {_subItm.title}
              </MenuItem>
            ))}
          </Menu>
        )}
      </React.Fragment>
    ));
  };

  const renderFooterLinks = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          fontSize: '11px',
          px: 1,
          pb: 2,
          pt: 1
        }}
      >
        <Link
          className='bodyText'
          sx={{
            color: colors.text.primaryTheme,
            cursor: 'pointer',
            fontSize: '11px !important'
          }}
          underline='none'
          onClick={() => {
            setOpenTermsModal(true);
            setOpenPrivacyModal(false);
          }}
        >
          Terms of Service
        </Link>
        <span>&nbsp;|&nbsp;</span>
        <Link
          className='bodyText'
          sx={{
            color: colors.text.primaryTheme,
            cursor: 'pointer',
            fontSize: '11px !important'
          }}
          underline='none'
          onClick={() => {
            setOpenTermsModal(false);
            setOpenPrivacyModal(true);
          }}
        >
          Privacy Policy
        </Link>
        <span>&nbsp;|&nbsp;</span>
        <Link
          className='bodyText'
          sx={{
            color: colors.text.primaryTheme,
            cursor: 'pointer',
            fontSize: '11px !important'
          }}
          underline='none'
          onClick={() => navigate('/aboutus')}
        >
          About 4um
        </Link>
        <span>&nbsp;|&nbsp;</span>
        <TypographyWithI18N
          className='metadata'
          i18nKey={`© ${currentYear} 4um`}
        />
      </Box>
    );
  };

  const renderUserDetails = () => {
    return (
      <>
        <Box
          id='userDetails'
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            margin: 'auto 0 16px',
            flexDirection: { xs: 'row', md: 'row', lg: 'row' },
            width: { md: 230, lg: 300 },
            marginLeft: { md: 'auto' }
          }}
        >
          <Box
            className='flexCenterJustify'
            ml={{ lg: 2 }}
            onClick={() => navigate(`/profile/${userProfile?.id}`)}
            sx={{ cursor: 'pointer', flexDirection: { xs: 'row', md: 'row', lg: 'row' } }}
          >
            <AvatarImg
              enableLetterImg={userProfile?.userImage?.id ? false : true}
              src={
                userProfile?.userImage?.id
                  ? userProfileUrl(userProfile?.userImage.id)
                  : ''
              }
              alt='user profile'
              id='user_profile'
              name={userProfile?.username}
              width={36}
              height={36}
              nameStyle={{
                fontSize: 14
              }}
              style={{
                borderRadius: '50%',
                background: colors.text.approxLightShade,
                objectFit: 'cover'
              }}
            />
            <Box flex={1} display={{ xs: 'block', md: 'block' }}>
              <TypographyWithI18N
                className='bodyTextBold'
                i18nKey={userProfile?.username}
                sx={{
                  pl: 1,
                  color: userNameActive(userProfile?.id)
                    ? colors.text.primaryTheme
                    : colors.text.primaryBlack
                }}
              />
              <TypographyWithI18N
                i18nKey={userProfile?.email}
                sx={{
                  pl: 1
                }}
              />
            </Box>
          </Box>
          <AdminIconButton
            id='long-button'
            aria-label='more'
            onClick={handleClick}
            icon={<MoreDotIcon />}
          />

         <Menu
  anchorEl={anchorEl}
  id='account-menu'
  open={openMenu}
  onClose={handleClose}
  onClick={handleClose}
  anchorOrigin={{
    vertical: 'top',
    horizontal: 'right'
  }}
  transformOrigin={{
    vertical: 'top',
    horizontal: 'right'
  }}
>
  <MenuItem
    onClick={() => {
      handleClose();
      navigate('/aboutus');
    }}
  >
    <ListItemIcon>
      <InfoOutlinedIcon fontSize='small' />
    </ListItemIcon>
    About 4um
  </MenuItem>

  <MenuItem
    onClick={() => {
      setOpenTermsModal(false);
      setOpenPrivacyModal(true);
    }}
  >
    <ListItemIcon>
      <PolicyOutlinedIcon fontSize='small' />
    </ListItemIcon>
    Privacy Policy
  </MenuItem>

  <MenuItem
    onClick={() => {
      setOpenTermsModal(true);
      setOpenPrivacyModal(false);
    }}
  >
    <ListItemIcon>
      <DescriptionOutlinedIcon fontSize='small' />
    </ListItemIcon>
    Terms of Service
  </MenuItem>

  <MenuItem
    onClick={() => {
      setOpenReportProblem(true);
    }}
  >
    <ListItemIcon>
      <ReportProblemIcon />
    </ListItemIcon>
    Report a Problem
  </MenuItem>

  <MenuItem
    onClick={() => {
      setOpenDialog({
        open: true
      });
    }}
  >
    <ListItemIcon>
      <LogOutIcon fontSize='small' style={{ height: '25px', width: '25px' }} />
    </ListItemIcon>
    {t('logOut')}
  </MenuItem>
</Menu>
        </Box>
        {openDialog.open && (
          <DialogActionWall
            open={openDialog.open}
            title={openDialog.open && !openDialog.successModal ? 'Logout' : ''}
            dialogTitleSxProps={{
              textAlign: 'center'
            }}
            dialogActionsSxProps={{
              justifyContent: 'center'
            }}
            onSuccess={logOutClick}
            onCancel={() =>
              setOpenDialog((pv: any) => ({
                ...pv,
                open: false
              }))
            }
            onSuccessBtnColor={'error'}
            loaderBtn={openDialog.loaderBtn}
            successLabel={'Logout'}
            dialogSuccessSxProps={{
              opacity: openDialog.loaderBtn ? 0.6 : 1,
              pointerEvents: openDialog.successModal ? 'none' : ''
            }}
            hideBtn={!openDialog.successModal}
            closeIconButton={openDialog.successModal}
            onClose={() => {
              setOpenDialog((pv: any) => ({
                ...pv,
                open: false,
                successModal: false
              }));
            }}
          >
            {openDialog.successModal ? (
              <Box className='flexCenterJustify flexCenterColumn'>
                <CheckGreenCircle />
                <TypographyWithI18N
                  textAlign={'center'}
                  mt={3}
                  className='headerBold'
                  color={colors.text.primaryBlack}
                  i18nKey={'You have successfully logged out from 4um.'}
                />
              </Box>
            ) : (
              <TypographyWithI18N
                textAlign={'center'}
                i18nKey={'Are you sure you want to logout the 4um?'}
              />
            )}
          </DialogActionWall>
        )}
        <ReportProblem
          open={openReportProblem}
          onClose={() => setOpenReportProblem(false)}
        />
      </>
    );
  };
  return (
    <>
      {/* Top AppBar for mobile */}
      <Box sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' }, justifyContent: 'space-between', alignItems: 'center', p: 1 }}>
        <IconButton onClick={handleDrawerToggle}>
          <MenuIcon />
        </IconButton>
        <Box
          sx={{ cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          <LogoSmallIcon width={'123px'} height={'32px'} />
        </Box>
        <Box width={40} />
      </Box>

      {/* Sidebar for medium and up */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          height: '100%'
        }}
      >
        <Box
          sx={{
            height: 70,
            display: 'flex',
            alignItems: 'center',
            margin: '0 auto',
            cursor: 'pointer',
            width: '200px'
          }}
          onClick={() => navigate('/')}
        >
          <LogoIcon width={'123px'} height={'32px'} />
        </Box>

        <List sx={{ margin: '0 auto', width: { md: 200 } }}>
          {renderListItems(listItems)}
        </List>
        {isLoggedIn ? renderUserDetails() : openSigninDialog && (
            <SigninModal
              guestModeOptions={guestModeOptions}
              openSigninDialog={openSigninDialog}
              closeSigninDialog={() => { setOpenSigninDialog(false); }}
            />  
        )}
      </Box>

      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', sm: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            width: { xs: '200px', sm: '250px' },
            boxSizing: 'border-box',
          }
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between'
          }}
        >
          <Box>
            <List sx={{ margin: '0 auto', width: { md: 200 } }}>
              {renderListItems(listItems)}
            </List>
            {isLoggedIn ? (
              renderUserDetails()
            ) : (
              openSigninDialog && (
                <SigninModal
                  guestModeOptions={guestModeOptions}
                  openSigninDialog={openSigninDialog}
                  closeSigninDialog={() => { setOpenSigninDialog(false); }}
                />
              )
            )}
          </Box>
          {renderFooterLinks()}
        </Box>
      </Drawer>

      {openPrivacyModal && (
        <PrivacyPolicy
          openModal={openPrivacyModal}
          setOpenModal={setOpenPrivacyModal}
        />
      )}
      {openTermsModal && (
        <TermsOfUse
          openModal={openTermsModal}
          setOpenModal={setOpenTermsModal}
        />
      )}
    </>
  );
};

export default SideBar;
